export default "__VITE_ASSET__DasxNeqX__"